import React, { useState, useEffect } from 'react';
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useAppId } from "../context/AppIdContext";
import '../style/login.css';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const LoginWithOTP = () => {
    // --- State & Logic ---
    const [step, setStep] = useState(1);
    const [mobile, setMobile] = useState("");
    const [otp, setOtp] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [mobileError, setMobileError] = useState("");

    // Data State
    const [userList, setUserList] = useState([]);
    const [uniqueVidhansabhas, setUniqueVidhansabhas] = useState([]);
    const [selectedVs, setSelectedVs] = useState(null);

    // Step 4 State
    const [filteredUsers, setFilteredUsers] = useState([]);
    const [finalUser, setFinalUser] = useState(null);

    const navigate = useNavigate();

    // Get context setters
    const {
        setAppId,
        setUserName,
        setUserPhoto,
        setUserId,
        setTotalVoters,
        language,
        setIsAuthenticated,
        // Additional fields to store
        setVidhanSabhaNo,
        setVidhanSabhaName,
        setCandidateNo,
        setCandidateName,
        setPartyShortName,
        setPartyFullName,
        setPartyLogoPng,
        setPartyLogoJpg,
        setSlipMessage,
        setSmsSlipMessage,
        setOfflineStatus,
        setOfflineDbUrl,
        setOfflineVer,
        setSplaceUrl,
        setAppLink,
        setVideoLink,
        setAppVer,
        setBoothNo,
        setTempStatus,
        setPopupStatus,
        setPopupUrl
    } = useAppId();

    const lang = language || 'en';

    // Translation dictionary
    const t = {
        en: {
            login: "Login",
            enterMobile: "Enter your mobile number to continue.",
            mobileNumber: "Mobile Number",
            mobilePlaceholder: "10-digit number",
            sendOTP: "Send OTP",
            sending: "Sending...",
            enterCode: "Enter code sent to +91 {mobile}",
            verifyLogin: "Verify & Login",
            verifying: "Verifying...",
            changeNumber: "Change number",
            selectVidhanSabha: "Select Vidhan Sabha",
            vidhanSabha: "Vidhan Sabha :",
            continue: "Continue",
            selectResponsibility: "Select Responsibility",
            back: "Back",
            admin: "Admin",
            subAdmin: "Sub Admin",
            volunteer: "Volunteer",
            boothPramukh: "Booth Pramukh",
            sahBoothPramukh: "Sah Booth Pramukh",
            validMobile: "Please enter a valid 10-digit mobile number",
            invalidNumber: "Invalid Number",
            serverError: "Server Error",
            enterOTP: "Please enter the OTP",
            invalidOTP: "Invalid OTP",
            noAccount: "No account found for this number.",
            verificationFailed: "Verification Failed",
            otpSent: "OTP sent successfully",
            mobileRequired: "Mobile number is required",
            mobileLength: "Mobile number must be 10 digits",
            mobileNumeric: "Mobile number must contain only digits",
            mobileInvalid: "Please enter a valid Indian mobile number (starts with 6,7,8,9)"
        },
        hi: {
            login: "लॉगिन",
            enterMobile: "जारी रखने के लिए अपना मोबाइल नंबर दर्ज करें।",
            mobileNumber: "मोबाइल नंबर",
            mobilePlaceholder: "10-अंकीय संख्या",
            sendOTP: "ओटीपी भेजें",
            sending: "भेजा जा रहा है...",
            enterCode: "+91 {mobile} पर भेजा गया कोड दर्ज करें",
            verifyLogin: "सत्यापित करें और लॉगिन करें",
            verifying: "सत्यापित किया जा रहा है...",
            changeNumber: "नंबर बदलें",
            selectVidhanSabha: "विधानसभा चुनें",
            vidhanSabha: "विधानसभा :",
            continue: "जारी रखें",
            selectResponsibility: "जिम्मेदारी चुनें",
            back: "वापस",
            admin: "एडमिन",
            subAdmin: "सब एडमिन",
            volunteer: "कार्यकर्ता",
            boothPramukh: "बूथ प्रमुख",
            sahBoothPramukh: "सह बूथ प्रमुख",
            validMobile: "कृपया एक वैध 10-अंकीय मोबाइल नंबर दर्ज करें",
            invalidNumber: "अमान्य नंबर",
            serverError: "सर्वर त्रुटि",
            enterOTP: "कृपया ओटीपी दर्ज करें",
            invalidOTP: "अमान्य ओटीपी",
            noAccount: "इस नंबर के लिए कोई खाता नहीं मिला।",
            verificationFailed: "सत्यापन विफल",
            otpSent: "ओटीपी सफलतापूर्वक भेजा गया",
            mobileRequired: "मोबाइल नंबर आवश्यक है",
            mobileLength: "मोबाइल नंबर 10 अंकों का होना चाहिए",
            mobileNumeric: "मोबाइल नंबर में केवल अंक होने चाहिए",
            mobileInvalid: "कृपया एक वैध भारतीय मोबाइल नंबर दर्ज करें (6,7,8,9 से शुरू)"
        },
        gu: {
            login: "લૉગિન",
            enterMobile: "ચાલુ રાખવા માટે તમારો મોબાઇલ નંબર દાખલ કરો.",
            mobileNumber: "મોબાઇલ નંબર",
            mobilePlaceholder: "10-અંકનો નંબર",
            sendOTP: "OTP મોકલો",
            sending: "મોકલાઈ રહ્યું છે...",
            enterCode: "+91 {mobile} પર મોકલેલ કોડ દાખલ કરો",
            verifyLogin: "ચકાસો અને લૉગિન કરો",
            verifying: "ચકાસાઈ રહ્યું છે...",
            changeNumber: "નંબર બદલો",
            selectVidhanSabha: "વિધાનસભા પસંદ કરો",
            vidhanSabha: "વિધાનસભા :",
            continue: "ચાલુ રાખો",
            selectResponsibility: "જવાબદારી પસંદ કરો",
            back: "પાછળ",
            admin: "એડમિન",
            subAdmin: "પેટા એડમિન",
            volunteer: "કાર્યકર્તા",
            boothPramukh: "બૂથ પ્રમુખ",
            sahBoothPramukh: "સહ બૂથ પ્રમુખ",
            validMobile: "કૃપા કરીને માન્ય 10-અંકનો મોબાઇલ નંબર દાખલ કરો",
            invalidNumber: "અમાન્ય નંબર",
            serverError: "સર્વર ભૂલ",
            enterOTP: "કૃપા કરીને OTP દાખલ કરો",
            invalidOTP: "અમાન્ય OTP",
            noAccount: "આ નંબર માટે કોઈ ખાતું મળ્યું નથી.",
            verificationFailed: "ચકાસણી નિષ્ફળ",
            otpSent: "OTP સફળતાપૂર્વક મોકલાયો",
            mobileRequired: "મોબાઇલ નંબર જરૂરી છે",
            mobileLength: "મોબાઇલ નંબર 10 અંકનો હોવો જોઈએ",
            mobileNumeric: "મોબાઇલ નંબરમાં માત્ર અંકો હોવા જોઈએ",
            mobileInvalid: "કૃપા કરીને માન્ય ભારતીય મોબાઇલ નંબર દાખલ કરો (6,7,8,9 થી શરૂ)"
        }
    };
    const handelKeyDown = (e) => {
        if (e.key === "Enter") {
            handleSendOTP();
        }
    };  
    const txt = t[lang];

    // --- Mobile Number Validation Functions ---
    const validateMobileNumber = (number) => {
        if (!number) {
            return { isValid: false, message: txt.mobileRequired };
        }
        if (!/^\d{10}$/.test(number)) {
            return { isValid: false, message: txt.mobileLength };
        }
        if (!/^\d+$/.test(number)) {
            return { isValid: false, message: txt.mobileNumeric };
        }
        const firstDigit = number.charAt(0);
        if (!['6', '7', '8', '9'].includes(firstDigit)) {
            return { isValid: false, message: txt.mobileInvalid };
        }
        return { isValid: true, message: "" };
    };

    const handleMobileChange = (e) => {
        const value = e.target.value;
        const numericValue = value.replace(/[^0-9]/g, '');
        const limitedValue = numericValue.slice(0, 10);
        setMobile(limitedValue);

        if (mobileError) {
            setMobileError("");
        }

        if (limitedValue.length > 0) {
            const validation = validateMobileNumber(limitedValue);
            if (!validation.isValid && limitedValue.length === 10) {
                setMobileError(validation.message);
            } else if (limitedValue.length > 0 && limitedValue.length < 10) {
                setMobileError(txt.mobileLength);
            } else {
                setMobileError("");
            }
        }
    };

    const handleSendOTP = async () => {
        const validation = validateMobileNumber(mobile);
        if (!validation.isValid) {
            setMobileError(validation.message);
            setError(validation.message);
            return;
        }

        setLoading(true);
        setError("");

        try {
            const response = await axios.post(
                `${BASE_URL}/api/send-otp`,
                { mobile_no: mobile }
            );
            if (response.data.success) {
                setStep(2);
            } else {
                setError(response.data.message || response.data.error || txt.invalidNumber);
            }
        } catch (err) {
            console.error(err);
            if (err.response && err.response.status >= 500) {
                setError(txt.serverError);
            } else {
                setError(err.response?.data?.message || err.response?.data?.error || txt.invalidNumber);
            }
        } finally {
            setLoading(false);
        }
    };

    const handleVerifyOTP = async () => {
        if (!otp) {
            setError(txt.enterOTP);
            return;
        }
        setLoading(true);
        setError("");

        try {
            const response = await axios.post(
                `${BASE_URL}/api/verify-otp`,
                { mobile_no: mobile, otp }
            );

            if (response.data.success) {
                const result = response.data.data.result;

                if (result.length === 1) {
                    loginUser(result[0]);
                } else if (result.length > 1) {
                    setUserList(result);
                    const uniqueVsMap = new Map();
                    result.forEach(user => {
                        if (!uniqueVsMap.has(user.vidhansabha_no)) {
                            uniqueVsMap.set(user.vidhansabha_no, user);
                        }
                    });
                    setUniqueVidhansabhas(Array.from(uniqueVsMap.values()));
                    setStep(3);
                } else {
                    setError(txt.noAccount);
                }
            } else {
                setError(txt.invalidOTP);
            }
        } catch (err) {
            console.error(err);
            setError(txt.verificationFailed);
        } finally {
            setLoading(false);
        }
    };

    const handelEnterDown = (e) => {
        if (e.key === "Enter") {
            handleVerifyOTP();
        }
    };

    const handleVsSelection = () => {
        if (!selectedVs) return;
        const usersInVs = userList.filter(u => u.vidhansabha_no === selectedVs.vidhansabha_no);

        if (usersInVs.length === 1) {
            loginUser(usersInVs[0]);
        } else {
            setFilteredUsers(usersInVs);
            setStep(4);
        }
    };

    const loginUser = (user) => {
        if (!user) return;

        // Store all user data in context
        setAppId(user.app_id);
        setUserName(user.name);
        setUserPhoto(user.photo_path || user.photo || null);
        setTotalVoters(user.total_voter);
        setUserId(user.user_id);

        // Store vidhan sabha details
        if (setVidhanSabhaNo) setVidhanSabhaNo(user.vidhansabha_no);
        if (setVidhanSabhaName) setVidhanSabhaName(user.vidhansabha_name);

        // Store candidate details
        if (setCandidateNo) setCandidateNo(user.candidate_no);
        if (setCandidateName) setCandidateName(user.candidate_name);

        // Store party details
        if (setPartyShortName) setPartyShortName(user.party_short_name);
        if (setPartyFullName) setPartyFullName(user.party_full_name);
        if (setPartyLogoPng) setPartyLogoPng(user.party_logo_png);
        if (setPartyLogoJpg) setPartyLogoJpg(user.party_logo_jpg);

        // Store slip messages
        if (setSlipMessage) setSlipMessage(user.slip_message);
        if (setSmsSlipMessage) setSmsSlipMessage(user.sms_slip_message);

        // Store offline settings
        if (setOfflineStatus) setOfflineStatus(user.offline_status);
        if (setOfflineDbUrl) setOfflineDbUrl(user.offline_db_url);
        if (setOfflineVer) setOfflineVer(user.offline_ver);

        // Store app settings
        if (setSplaceUrl) setSplaceUrl(user.splace_url);
        if (setAppLink) setAppLink(user.app_link);
        if (setVideoLink) setVideoLink(user.video_link);
        if (setAppVer) setAppVer(user.app_ver);

        // Store user type and booth
        if (setBoothNo) setBoothNo(user.booth_no);
        if (setTempStatus) setTempStatus(user.temp_status);

        // Store popup settings
        if (setPopupStatus) setPopupStatus(user.popup_status);
        if (setPopupUrl) setPopupUrl(user.popup_url);

        // Set authentication state
        setIsAuthenticated(true);

        // Save to localStorage
        localStorage.setItem('appId', user.app_id);
        localStorage.setItem('userName', user.name);
        localStorage.setItem('userId', user.user_id);
        if (user.total_voter) localStorage.setItem('totalVoters', user.total_voter);
        if (user.photo_path || user.photo) localStorage.setItem('userPhoto', user.photo_path || user.photo);

        // Save vidhan sabha data
        localStorage.setItem('vidhanSabhaNo', user.vidhansabha_no);
        localStorage.setItem('vidhanSabhaName', user.vidhansabha_name);

        // Save candidate data
        localStorage.setItem('candidateNo', user.candidate_no);
        localStorage.setItem('candidateName', user.candidate_name);

        // Save party data
        localStorage.setItem('partyShortName', user.party_short_name);
        localStorage.setItem('partyFullName', user.party_full_name);
        localStorage.setItem('partyLogoPng', user.party_logo_png);
        localStorage.setItem('partyLogoJpg', user.party_logo_jpg);

        // Save slip messages
        localStorage.setItem('slipMessage', user.slip_message);
        localStorage.setItem('smsSlipMessage', user.sms_slip_message);

        // Save offline settings
        localStorage.setItem('offlineStatus', user.offline_status);
        localStorage.setItem('offlineDbUrl', user.offline_db_url);
        localStorage.setItem('offlineVer', user.offline_ver);

        // Save app settings
        localStorage.setItem('splaceUrl', user.splace_url || '');
        localStorage.setItem('appLink', user.app_link || '');
        localStorage.setItem('videoLink', user.video_link || '');
        localStorage.setItem('appVer', user.app_ver || '');

        // Save user type and booth
        localStorage.setItem('userType', user.user_type);
        localStorage.setItem('boothNo', user.booth_no || '');
        localStorage.setItem('tempStatus', user.temp_status || '');

        // Save popup settings
        localStorage.setItem('popupStatus', user.popup_status);
        localStorage.setItem('popupUrl', user.popup_url || '');

        // Save complete user object for reference
        localStorage.setItem('userData', JSON.stringify(user));

        navigate("/dashboard");
    };

    const getUserTypeLabel = (type) => {
        const map = {
            'A': txt.admin,
            'SA': txt.subAdmin,
            'sa': txt.subAdmin,
            'K': txt.volunteer,
            'k': txt.volunteer,
            'BP': txt.boothPramukh,
            'BS': txt.sahBoothPramukh
        };
        return map[type] || type || 'User';
    };

    return (
        <div className="login-container">
            {/* Background Pattern */}
            <div className="background-pattern">
                <div className="pattern-dots"></div>
            </div>

            <div className="login-wrapper">
                {/* Left Side - Minimalist Brand */}
                <div className="brand-section">
                    <div className="brand-content">
                        <div className="brand-icon">
                            <img src='https://maharashtra.bjpwings.com/img/admin/09022026022058_1770632573055.jpg' style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%' }} alt="BJP Logo" />
                        </div>
                        <h1 className="brand-name">BJP<br />Wings</h1>
                        <div className="brand-year"></div>
                    </div>
                </div>

                {/* Right Side - Login Form */}
                <div className={`login-section ${step >= 3 ? 'wide-section' : ''}`}>
                    

                    {/* Header */}
                    <div className="login-header m-1">
                        <h2 className="login-title">
                            {step === 1 && txt.login}
                            {step === 2 && "Verification"}
                            {step === 3 && txt.selectVidhanSabha}
                            {step === 4 && "Choose Profile"}
                        </h2>
                        {step === 1 && <p className="login-subtitle">{txt.enterMobile}</p>}
                        {step === 2 && <p className="login-subtitle">{txt.enterCode.replace('{mobile}', mobile)}</p>}
                    </div>

                    {/* STEP 1: Mobile Input */}
                    {step === 1 && (
                        <div className="form-container">
                            <div className="input-group">
                                <label className="input-label">{txt.mobileNumber}</label>
                                <div className={`phone-input ${mobileError ? 'error' : ''}`}>
                                    <span className="country-code">+91</span>
                                    <div className="input-divider"></div>
                                    <input
                                        type="tel"
                                        className="input-field"
                                        placeholder={txt.mobilePlaceholder}
                                        value={mobile}
                                        onChange={handleMobileChange}
                                        maxLength={10}
                                        onKeyDown={handelKeyDown}
                                    />
                                </div>
                                {mobileError && (
                                    <div className="mobile-error-message">
                                        <span className="error-icon-small">⚠️</span>
                                        <span>{mobileError}</span>
                                    </div>
                                )}
                            </div>

                            <button
                                className="login-btn"
                                onClick={handleSendOTP}
                                disabled={loading || !mobile || mobile.length !== 10 || mobileError}
                            >
                                {loading ? (
                                    <div className="loader"></div>
                                ) : txt.sendOTP}
                            </button>
                        </div>
                    )}

                    {/* STEP 2: OTP Input (UPDATED TO 6 DIGITS) */}
                    {step === 2 && (
                        <div className="form-container">
                            <div className="otp-section">
                                <div className="otp-inputs">
                                    {Array.from({ length: 6 }).map((_, index) => (
                                        <div
                                            key={index}
                                            className={`otp-digit ${otp[index] ? 'filled' : ''} ${otp.length === index ? 'active-digit' : ''}`}
                                        >
                                            {otp[index] || ''}
                                        </div>
                                    ))}
                                </div>
                                <input
                                    type="text"
                                    inputMode="numeric"
                                    pattern="[0-9]*"
                                    value={otp}
                                    onChange={(e) => {
                                        const value = e.target.value.replace(/[^0-9]/g, '');
                                        setOtp(value.slice(0, 6));
                                    }}
                                    autoFocus
                                    className="otp-hidden-input"
                                    onKeyDown={handelEnterDown}
                                />
                            </div>

                            <button
                                className="login-btn"
                                onClick={handleVerifyOTP}
                                disabled={loading || otp.length !== 6}
                            >
                                {loading ? (
                                    <div className="loader"></div>
                                ) : txt.verifyLogin}
                            </button>

                            <button className="change-link" onClick={() => { setStep(1); setOtp(""); setError(""); setMobileError(""); }}>
                                ← {txt.changeNumber}
                            </button>
                        </div>
                    )}

                    {/* STEP 3: Vidhan Sabha Selection */}
                    {step === 3 && (
                        <div className="selection-container">
                            <div className="items-list-wrapper">
                                <div className="items-list scrollable-list">
                                    {uniqueVidhansabhas.map((vs) => (
                                        <button
                                            key={vs.vidhansabha_no}
                                            className={`item-card ${selectedVs?.vidhansabha_no === vs.vidhansabha_no ? 'selected' : ''}`}
                                            onClick={() => setSelectedVs(vs)}
                                        >
                                            <span className="item-number">{vs.vidhansabha_no}</span>
                                            <span className="item-name">{vs.vidhansabha_name}</span>
                                        </button>
                                    ))}
                                </div>
                            </div>

                            <button
                                className="login-btn"
                                onClick={handleVsSelection}
                                disabled={!selectedVs}
                            >
                                {txt.continue}
                            </button>
                        </div>
                    )}

                    {/* STEP 4: User Profile Selection */}
                    {step === 4 && (
                        <div className="selection-container p-0 m-0">
                            <div className="selection-header">  
                                <button className="back-btn" onClick={() => { setStep(3); setFinalUser(null); }}>
                                    <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M19 12H5M12 19l-7-7 7-7" /></svg>
                                </button>
                                <span className="header-title">{selectedVs?.vidhansabha_name}</span>
                            </div>

                            <div className="user-list-wrapper" style={{ maxHeight: '150px', overflowY: 'auto' }}>
                                <div className="user-list">
                                    {filteredUsers.map((user) => (
                                        <button
                                            key={user.user_id}
                                            className={`profile-card ${finalUser?.user_id === user.user_id ? 'selected' : ''}`}
                                            onClick={() => setFinalUser(user)}
                                        >
                                            <div className="profile-avatar">
                                                {user.photo_path ? (
                                                    <img src={user.photo_path} alt={user.name} />
                                                ) : (
                                                    <span className="avatar-initials">{user.name?.charAt(0)}</span>
                                                )}
                                            </div>
                                            <div className="profile-info">
                                                <span className="profile-name">{user.name}</span>
                                                <span className="profile-badge">
                                                    {getUserTypeLabel(user.user_type)}
                                                </span>
                                            </div>
                                        </button>
                                    ))}
                                </div>
                            </div>

                            <button
                                className="login-btn"
                                onClick={() => loginUser(finalUser)}
                                disabled={!finalUser}
                            >
                                {txt.login}
                            </button>
                        </div>
                    )}

                    {/* Error Message */}
                    {error && (
                        <div className="error-toast">
                            <span className="error-icon">!</span>
                            <span className="error-text">{error}</span>
                        </div>
                    )}
                </div>
            </div>

            <style jsx>{`
                .login-container {
                    min-height: 100vh;
                    background: #f8fafc;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding: 20px;
                    position: relative;
                    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
                }

                .background-pattern {
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    top: 0;
                    left: 0;
                    pointer-events: none;
                }

                .pattern-dots {
                    width: 100%;
                    height: 100%;
                    background-image: radial-gradient(#cbd5e1 1px, transparent 1px);
                    background-size: 32px 32px;
                    opacity: 0.4;
                }

                .login-wrapper {
                    display: flex;
                    width: 100%;
                    max-width: 900px;
                    background: #ffffff;
                    border-radius: 24px;
                    overflow: hidden;
                    position: relative;
                    z-index: 1;
                    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.15), 0 10px 15px -3px rgba(0, 0, 0, 0.05);
                }

                /* Left Brand Section */
                .brand-section {
                    width: 320px;
                    background: linear-gradient(135deg, #2563EB 0%, #1D4ED8 100%);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding: 48px 32px;
                    position: relative;
                    overflow: hidden;
                }

                .brand-section::after {
                    content: '';
                    position: absolute;
                    width: 200%;
                    height: 200%;
                    background: radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 60%);
                    top: -50%;
                    left: -50%;
                }

                .brand-content {
                    text-align: center;
                    position: relative;
                    z-index: 2;
                }

                .brand-icon {
                    width: 88px;
                    height: 88px;
                    margin: 0 auto 24px;
                    border-radius: 50%;
                    background: rgba(255, 255, 255, 0.2);
                    padding: 4px;
                    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
                }

                .brand-name {
                    color: white;
                    font-size: 32px;
                    font-weight: 700;
                    line-height: 1.1;
                    margin: 0 0 16px;
                    letter-spacing: 1px;
                }

                /* Right Login Section */
                .login-section {
                    flex: 1;
                    padding: 56px 64px;
                    background: white;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                }

                .wide-section {
                    max-width: 580px;
                }

                /* Step Indicator */
                .step-indicator {
                    text-align: right;
                    margin-bottom: 24px;
                }

                .current-step {
                    font-size: 13px;
                    font-weight: 600;
                    color: #94a3b8;
                    background: #f1f5f9;
                    padding: 6px 12px;
                    border-radius: 20px;
                    letter-spacing: 0.5px;
                }

                /* Header */
                .login-header {
                    margin-bottom: 40px;
                }

                .login-title {
                    font-size: 32px;
                    font-weight: 800;
                    color: #0f172a;
                    margin: 0 0 12px;
                    letter-spacing: -0.5px;
                }

                .login-subtitle {
                    color: #64748b;
                    font-size: 15px;
                    margin: 0;
                    line-height: 1.5;
                }

                /* Form Container */
                .form-container {
                    max-width: 360px;
                }

                /* Input Group */
                .input-group {
                    margin-bottom: 32px;
                }

                .input-label {
                    display: block;
                    font-size: 13px;
                    font-weight: 600;
                    color: #475569;
                    margin-bottom: 8px;
                }

                .phone-input {
                    width: 100%;
                    display: flex;
                    align-items: center;
                    background: #f8fafc;
                    border: 1px solid #cbd5e1;
                    border-radius: 12px;
                    padding: 4px 16px;
                    transition: all 0.2s ease;
                }

                .phone-input.error {
                    border-color: #ef4444;
                }

                .phone-input.error:focus-within {
                    border-color: #ef4444;
                    box-shadow: 0 0 0 4px rgba(239, 68, 68, 0.1);
                }

                .phone-input:focus-within {
                    background: #ffffff;
                    border-color: #2563EB;
                    box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.1);
                }

                .country-code {
                    color: #0f172a;
                    font-size: 16px;
                    font-weight: 500;
                }

                .input-divider {
                    width: 1px;
                    height: 24px;
                    background: #cbd5e1;
                    margin: 0 12px;
                }

                .input-field {
                    flex: 1;
                    padding: 14px 0;
                    border: none;
                    outline: none;
                    font-size: 16px;
                    font-weight: 500;
                    color: #0f172a;
                    background: transparent;
                    letter-spacing: 1px;
                }
                
                .input-field::placeholder {
                    color: #94a3b8;
                    font-weight: 400;
                    letter-spacing: normal;
                }

                .mobile-error-message {
                    display: flex;
                    align-items: center;
                    gap: 6px;
                    margin-top: 8px;
                    font-size: 12px;
                    color: #ef4444;
                    background: #fef2f2;
                    padding: 8px 12px;
                    border-radius: 8px;
                }

                .error-icon-small {
                    font-size: 12px;
                }

                /* OTP Section */
                .otp-section {
                    margin-bottom: 36px;
                    position: relative;
                }

                .otp-inputs {
                    display: flex;
                    gap: 12px;
                    justify-content: flex-start;
                }

                .otp-digit {
                    width: 42px; /* Reduced for 6 digits */
                    height: 52px; /* Reduced for 6 digits */
                    border: 1px solid #cbd5e1;
                    border-radius: 12px;
                    background: #f8fafc;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 20px; /* Reduced slightly */
                    font-weight: 600;
                    color: #0f172a;
                    transition: all 0.2s ease;
                }

                .otp-digit.filled {
                    background: #ffffff;
                    border-color: #2563eb;
                    color: #2563eb;
                    box-shadow: 0 2px 8px rgba(37, 99, 235, 0.1);
                }

                .otp-digit.active-digit {
                    border-color: #2563eb;
                    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);
                    background: #ffffff;
                }

                .otp-hidden-input {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    opacity: 0;
                    cursor: pointer;
                    letter-spacing: 30px; 
                }

                /* Selection Container */
                .selection-container {
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                }

                .items-list-wrapper {
                    margin-bottom: 24px;
                    max-height: 320px;
                    overflow-y: auto;
                }

                /* User List - Reduced Height */
                .user-list-wrapper {
                    margin-bottom: 24px;
                    max-height: 280px;
                    overflow-y: auto;
                }

                .items-list {
                    padding: 4px;
                }

                .user-list {
                    padding: 4px;
                }

                .scrollable-list {
                    max-height: 100%;
                    overflow-y: auto;
                }

                .scrollable-user-list {
                    max-height: 100%;
                    overflow-y: auto;
                }

                .selection-header {
                    display: flex;
                    align-items: center;
                    gap: 16px;
                    margin-bottom: 24px;
                    padding-bottom: 16px;
                    border-bottom: 1px solid #f1f5f9;
                }

                .back-btn {
                    width: 36px;
                    height: 36px;
                    border: 1px solid #e2e8f0;
                    border-radius: 10px;
                    background: #f8fafc;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    color: #475569;
                    transition: all 0.2s;
                }

                .back-btn:hover {
                    background: #f1f5f9;
                    color: #0f172a;
                    border-color: #cbd5e1;
                }

                .header-title {
                    font-size: 18px;
                    font-weight: 700;
                    color: #0f172a;
                }

                .item-card {
                    width: 100%;
                    padding: 16px 20px;
                    border: 1px solid #e2e8f0;
                    border-radius: 12px;
                    background: white;
                    display: flex;
                    align-items: center;
                    gap: 16px;
                    margin-bottom: 10px;
                    cursor: pointer;
                    transition: all 0.2s ease;
                    text-align: left;
                }

                .item-card:hover {
                    border-color: #cbd5e1;
                    background: #f8fafc;
                    transform: translateY(-1px);
                    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
                }

                .item-card.selected {
                    background: #eff6ff;    
                    border-color: #2563eb;
                    box-shadow: 0 0 0 1px #2563eb;
                }

                .item-number {
                    font-size: 14px;
                    font-weight: 700;
                    color: #64748b;
                    min-width: 44px;
                    background: #f1f5f9;
                    padding: 4px 8px;
                    border-radius: 6px;
                    text-align: center;
                }
                
                .item-card.selected .item-number {
                    background: #dbeafe;
                    color: #1d4ed8;
                }

                .item-name {
                    font-size: 15px;
                    color: #0f172a;
                    font-weight: 600;
                }

                /* Profile Card */
                .profile-card {
                    width: 100%;
                    padding: 16px;
                    border: 1px solid #e2e8f0;
                    border-radius: 16px;
                    background: white;
                    display: flex;
                    align-items: center;
                    gap: 16px;
                    margin-bottom: 12px;
                    cursor: pointer;
                    transition: all 0.2s ease;
                    text-align: left;
                }

                .profile-card:hover {
                    border-color: #cbd5e1;
                    background: #f8fafc;
                    transform: translateY(-2px);
                    box-shadow: 0 4px 12px rgba(0,0,0,0.05);
                }

                .profile-card.selected {
                    background: #eff6ff;
                    border-color: #2563eb;
                    box-shadow: 0 0 0 1px #2563eb;
                }

                .profile-avatar {
                    width: 52px;
                    height: 52px;
                    border-radius: 50%;
                    background: #e2e8f0;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: #64748b;
                    overflow: hidden;
                    flex-shrink: 0;
                    border: 2px solid #ffffff;
                    box-shadow: 0 2px 4px rgba(0,0,0,0.05);
                }

                .profile-avatar img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }

                .avatar-initials {
                    font-weight: 700;
                    font-size: 20px;
                    color: #475569;
                }

                .profile-info {
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    gap: 4px;
                }

                .profile-badge {
                    align-self: flex-start;
                    font-size: 11px;
                    font-weight: 700;
                    color: #2563eb;
                    background: #dbeafe;
                    padding: 2px 8px;
                    border-radius: 12px;
                    text-transform: uppercase;
                    letter-spacing: 0.5px;
                }

                .profile-name {
                    font-size: 16px;
                    font-weight: 700;
                    color: #0f172a;
                }

                /* Login Button */
                .login-btn {
                    width: 100%;
                    padding: 16px;
                    background: #2563EB;
                    color: white;
                    border: none;
                    border-radius: 14px;
                    font-size: 15px;
                    font-weight: 600;
                    letter-spacing: 0.5px;
                    cursor: pointer;
                    transition: all 0.2s ease;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    box-shadow: 0 4px 6px -1px rgba(37, 99, 235, 0.2);
                }

                .login-btn:hover:not(:disabled) {
                    background: #1D4ED8;
                    transform: translateY(-2px);
                    box-shadow: 0 8px 15px -3px rgba(37, 99, 235, 0.3);
                }

                .login-btn:disabled {
                    opacity: 0.5;
                    cursor: not-allowed;
                    transform: none;
                    box-shadow: none;
                }

                /* Change Link */
                .change-link {
                    background: none;
                    border: none;
                    color: #64748b;
                    font-size: 14px;
                    font-weight: 500;
                    cursor: pointer;
                    padding: 20px 0 0;
                    width: 100%;
                    transition: all 0.2s ease;
                }

                .change-link:hover {
                    color: #0f172a;
                }

                /* Loader */
                .loader {
                    width: 20px;
                    height: 20px;
                    border: 3px solid rgba(255, 255, 255, 0.3);
                    border-radius: 50%;
                    border-top-color: white;
                    animation: spin 0.8s linear infinite;
                }

                @keyframes spin {
                    to { transform: rotate(360deg); }
                }

                /* Error Toast */
                .error-toast {
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    padding: 12px 16px;
                    background: #fef2f2;
                    border: 1px solid #fecaca;
                    border-radius: 12px;
                    margin-top: 24px;
                    animation: slideUp 0.3s ease;
                }
                
                @keyframes slideUp {
                    from { opacity: 0; transform: translateY(10px); }
                    to { opacity: 1; transform: translateY(0); }
                }

                .error-icon {
                    width: 24px;
                    height: 24px;
                    background: #ef4444;
                    color: white;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 14px;
                    font-weight: bold;
                    flex-shrink: 0;
                }

                .error-text {
                    color: #991b1b;
                    font-size: 14px;
                    font-weight: 500;
                }

                /* Scrollbar Styling */
                .items-list-wrapper::-webkit-scrollbar,
                .user-list-wrapper::-webkit-scrollbar,
                .scrollable-list::-webkit-scrollbar,
                .scrollable-user-list::-webkit-scrollbar {
                    width: 6px;
                }

                .items-list-wrapper::-webkit-scrollbar-track,
                .user-list-wrapper::-webkit-scrollbar-track,
                .scrollable-list::-webkit-scrollbar-track,
                .scrollable-user-list::-webkit-scrollbar-track {
                    background: #f1f5f9;
                    border-radius: 4px;
                }

                .items-list-wrapper::-webkit-scrollbar-thumb,
                .user-list-wrapper::-webkit-scrollbar-thumb,
                .scrollable-list::-webkit-scrollbar-thumb,
                .scrollable-user-list::-webkit-scrollbar-thumb {
                    background: #cbd5e1;
                    border-radius: 4px;
                }
                
                .items-list-wrapper::-webkit-scrollbar-thumb:hover,
                .user-list-wrapper::-webkit-scrollbar-thumb:hover,
                .scrollable-list::-webkit-scrollbar-thumb:hover,
                .scrollable-user-list::-webkit-scrollbar-thumb:hover {
                    background: #94a3b8;
                }

                /* --- ENHANCED RESPONSIVE QUERIES --- */
                @media (max-width: 768px) {
                    .login-wrapper {
                        flex-direction: column;
                        max-width: 500px;
                        width: 100%;
                    }

                    .brand-section {
                        width: 100%;
                        padding: 24px 30px;
                    }
                    
                    .form-container {
                        max-width: none;
                    }

                    .brand-content {
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        justify-content: center;
                        gap: 16px;
                        text-align: left;
                    }

                    .brand-icon {
                        width: 56px;
                        height: 56px;
                        margin: 0;
                    }

                    .brand-name {
                        display: flex;
                        align-items: center;
                        gap: 8px;
                        font-size: 24px;
                        margin: 0;
                        line-height: 1.1;
                    }

                    .brand-name br {
                        display: none;
                    }

                    .login-section {
                        padding: 40px 32px;
                    }

                    .login-title {
                        font-size: 28px;
                    }
                    
                    .items-list-wrapper {
                        max-height: 280px;
                    }
                    
                    .user-list-wrapper {
                        max-height: 240px;
                    }
                }

                @media (max-width: 480px) {
                    .login-container {
                        padding: 16px;
                    }

                    .login-wrapper {
                        border-radius: 20px;
                    }

                    .brand-section {
                        padding: 20px 16px;
                    }

                    .login-section {
                        padding: 24px 16px;
                    }

                    .form-container {
                        max-width: 100%;
                    }

                    .otp-inputs {
                        gap: 6px; /* Reduced gap */
                    }

                    .otp-digit {
                        flex: 1;
                        max-width: 36px; /* Reduced for 6 boxes */
                        height: 46px; /* Reduced height */
                        font-size: 18px; /* Slightly smaller text */
                        border-radius: 10px;
                    }   

                    .profile-avatar {
                        width: 40px;
                        height: 40px;
                    }
                    
                    .login-title {
                        font-size: 24px;
                    }
                    
                    .item-card {
                        padding: 12px;
                    }
                    
                    .profile-card {
                        padding: 10px;
                    }

                    .mobile-error-message {
                        font-size: 10px;
                        padding: 6px 10px;
                    }
                    
                    .items-list-wrapper {
                        max-height: 260px;
                    }
                    
                    .user-list-wrapper {
                        max-height: 160px;
                    }
                }
            `}</style>
        </div>
    );
};

export default LoginWithOTP;